/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import './Documents.css';
import ActiveDocsController from '../../../domain/myProfile/documents/ActiveDocuments/ActiveDocsController';
import ExpiredDocsController from '../../../domain/myProfile/documents/ExpiredDocuments/ExpiredDocsController';
import { useAppSelector } from '../../../infra/hooks';

interface docProp {
  trans?: any;
  i18n?: any;
}
const DocumentsPresenter = ({ trans, i18n }: docProp) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            isHRView && i18n.language == 'en'
              ? '11em'
              : !isHRView && i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
        }}
      >
        <Grid
          container
          spacing={0}
          style={{
            paddingLeft: isHRView ? '2em' : '',
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: '100%',
            }}
          >
            <Grid
              container
              style={{
                width: 'auto',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                borderRadius: '10px',
                opacity: '1',
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '1em',
                paddingBottom: '1em',
                paddingLeft: '1em',
                paddingRight: '1em',
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Documents')}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginBottom: '24em' }}>
              <Grid item xs={12}></Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <ActiveDocsController />
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <ExpiredDocsController />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default DocumentsPresenter;
